import React, { useEffect, useState } from 'react';
import MUIDataTable from 'mui-datatables';
import { tableSettings } from './auditTrailTableSettings';
import { treatmentTableSettings } from './auditTrailTreatmentTableSettings';
import { useFetchAuditTrails } from '../../../../AppSrc/actions/areas/admin/fetchHooks/fetchAudit';
import LoadingPageText from '../../../../AppSrc/components/common/Loading/LoadingPageText';
import { AuditTrailType } from '../../../enums/auditTrail';
import globals from '../../../globals/communityGlobals';

const locale = globals.getArea('audit');

export default function AuditTrail({ auditTrailType, entityId, forceReload }) {
  const { data, isDataLoading } = useFetchAuditTrails(auditTrailType, entityId, forceReload);
  const [events, setEvents] = useState([]);
  const settings = AuditTrailType.Treatment === auditTrailType ? treatmentTableSettings(events) : tableSettings();

  useEffect(() => {
    if (data && data.eventEntries) {
      setEvents(data.eventEntries);
    }
  }, [data, isDataLoading]);

  return (
    <React.Fragment>
      {!isDataLoading ? (
        <MUIDataTable
          className="audit-trail-wrapp"
          style={{ width: '100%' }}
          columns={settings.columns}
          options={settings.options}
          data={events}
        />
      ) : (
        <LoadingPageText showHeader={false}>{locale.getMsg('auditLoadingMsg')}</LoadingPageText>
      )}
    </React.Fragment>
  );
}
